import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'sigecom-set-scoreboard',
  template: `
<div class="flex flex-row gap-4 ">
  <div *ngFor="let set of sets; let i = index" class="relative flex flex-col items-center">
    <span class="text-xs text-sigecom-dark-gray mb-1">{{ i + 1 }}º set</span>

<div class="grid grid-rows-2 gap-y-2 items-center">

    <ng-container *ngIf="i === 0">
      <label class="text-sm font-semibold text-cbde-dark-blue row-start-1 col-start-1 mr-4">Vencedor</label>
      <label class="text-sm font-semibold text-cbde-dark-blue row-start-2 col-start-1">Perdedor</label>
    </ng-container>

      <input
        type="number"
        class="w-14 h-10 text-center text-sigecom-gray border rounded border-sigecom-gray row-start-1 col-start-2 mr-4 "
        [value]="set.vencedor"
        (input)="updateScore(i, 'vencedor', $any($event.target).valueAsNumber || 0)"
      />
      <input
        type="number"
        class="w-14 h-10 text-center border rounded text-sigecom-gray border-sigecom-gray row-start-2 col-start-2 mr-4"
        [value]="set.perdedor"
        (input)="updateScore(i, 'perdedor', $any($event.target).valueAsNumber || 0)"
      />

      <ng-container *ngIf="i === sets.length - 1">
        <button
          *ngIf="i > 0"
          type="button"
          (click)="removeSet(i)"
          class="w-10 h-10 border rounded text-xl font-bold border-sigecom-dark-gray text-sigecom-dark-gray hover:bg-sigecom-item-selected transition row-start-1 col-start-3"
          title="Remover set"
        >
          −
        </button>

<button
  *ngIf="sets.length > 1 && sets.length < 10 ; else fullAdd"
  type="button"
  (click)="onAddSet()"
  class="w-10 h-10 border rounded text-xl font-bold border-sigecom-dark-gray text-sigecom-dark-gray hover:bg-sigecom-item-selected transition row-start-2 col-start-3"
>
  +
</button>

<ng-template #fullAdd>
  <button
    *ngIf="sets.length < 10"
    type="button"
    (click)="onAddSet()"
    class="w-10 h-20 border rounded text-xl font-bold border-sigecom-dark-gray text-sigecom-dark-gray hover:bg-sigecom-item-selected transition row-span-2 col-start-3"
  >
    +
  </button>
</ng-template>

      </ng-container>
    </div>
  </div>
</div>
  `
})
export class SetScoreboardComponent implements OnChanges {
  @Input() sets: {
    vencedor: number;
    perdedor: number;
    ptwIdVencedor?: number;
    ptwIdPerdedor?: number;
  }[] = [];

  @Output() setsChange = new EventEmitter<typeof this.sets>();
  @Output() setsRemoved = new EventEmitter<number[]>();

  private removedIds: number[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sets'] && Array.isArray(this.sets) && this.sets.length === 0) {
      this.sets.push({ vencedor: 0, perdedor: 0 });
    }
  }

  updateScore(index: number, key: 'vencedor' | 'perdedor', value: number) {
    this.sets[index][key] = value;
    this.emitChange();
  }

  onAddSet() {
    if (this.sets.length >= 10) return;
    this.sets.push({ vencedor: 0, perdedor: 0 });
    this.emitChange();
  }

  removeSet(index: number) {
    const removed = this.sets.splice(index, 1)[0];
    if (removed.ptwIdVencedor) this.removedIds.push(removed.ptwIdVencedor);
    if (removed.ptwIdPerdedor) this.removedIds.push(removed.ptwIdPerdedor);
    this.emitChange();
  }

  private emitChange() {
    this.setsChange.emit([...this.sets]);
    if (this.removedIds.length > 0) {
      this.setsRemoved.emit([...this.removedIds]);
      this.removedIds = [];
    }
  }
}





